import { District } from './district';


export class DistrictGroup {
    id: number;
    name: string;
    districts: District[];
}
